import { render, staticRenderFns } from "./ActivitySelectDialog.vue?vue&type=template&id=06ca5f98&scoped=true"
import script from "./ActivitySelectDialog.vue?vue&type=script&lang=js"
export * from "./ActivitySelectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca5f98",
  null
  
)

export default component.exports